// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SXIW","content":"styles_content__bs-6Y","tableWrap":"styles_tableWrap__1mdwd"};